exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-obt__name[data-v-0d123ea2]{min-width:200px}.pi-obt__toggle[data-v-0d123ea2]{width:20px;height:20px;margin-right:4px;padding:0;border:1px solid #c5cad3;border-radius:3px;background:#fff;color:#3a424e;font-size:11px;line-height:18px;cursor:pointer}.pi-obt__detail>td[data-v-0d123ea2]{background:#fafbfc}.pi-obt__facts[data-v-0d123ea2]{display:flex;flex-wrap:wrap;gap:4px 18px;margin:8px 0 0;font-size:12px;color:#4e5560}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d123ea2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/vue/pages/components/pi/piOnboardingCompanyTable.vue
// module id = 1763
// module chunks = 0